import { useCasaviSettingsGetQuery } from "@/common/api/casavi/settings/use-casavi-settings-get.query";
import { SettingsCard } from "@/components/dashboard/cards/settings-card";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";

export function CasaviSettings() {
  const { t } = useTranslation(["casavi", "common"]);
  const { data: settings, isLoading } = useCasaviSettingsGetQuery();

  if (isLoading) {
    return (
      <div className="flex items-center gap-4">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-20" />
      </div>
    );
  }

  return (
    <SettingsCard>
      <SettingsCard.Item label={t("casavi:Cronjob")} enabled={settings?.cronEnabled ?? false} />
      <SettingsCard.Item label={t("casavi:Start")} enabled={settings?.runOnStartup ?? false} />
      <SettingsCard.Item label={t("casavi:TestMode")} enabled={settings?.dryRun ?? false} />
    </SettingsCard>
  );
}
